import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Text, ActionIcon, Center,
} from '@mantine/core';
import { openConfirmModal } from '@mantine/modals';

import { NARROW_COLUMN_STYLES } from './constants';

export default function useColDeleteSchema({
    project, disabledAccessor, onDelete,
}) {
    function openDeleteModal(e) {
        const { id, title } = e.currentTarget.dataset;

        openConfirmModal({
            title: 'Вы уверены, что хотите удалить запись?',
            children: (
                <Text size="sm">
                    «
                    {title}
                    »
                </Text>
            ),
            labels: { confirm: 'Удалить', cancel: 'Отмена' },
            confirmProps: { color: 'red' },
            onConfirm: () => onDelete(id, project),
        });
    }

    const colDeleteSchema = {
        accessor: 'controls-delete',
        style: NARROW_COLUMN_STYLES,
        title: (
            <Center>
                <FontAwesomeIcon icon="trash-alt" />
            </Center>
        ),
        render: ({ row }) => (
            <Center>
                <ActionIcon
                    color="red"
                    variant="light"
                    size="sm"
                    data-id={row.id}
                    data-title={row.title || row.name || row.entity?.content?.[0]?.title}
                    disabled={row[disabledAccessor]}
                    onClick={openDeleteModal}
                >
                    <FontAwesomeIcon icon="trash-alt" />
                </ActionIcon>
            </Center>
        ),
    };

    return colDeleteSchema;
}
